<template>
    <PbChatLauncher :chat="supportChat" />
</template>

<script setup lang="ts">
/**
 * The one way support chat opens in checkout.
 *
 * The facade and the hand-off live in `pb-chat-widget`. Checkout reserves no
 * page's corner and hands the widget to nothing else, so it passes no route
 * rules: every step of the funnel offers chat, and the button retires itself
 * once the SDK has taken the corner.
 */
import PbChatLauncher from 'pb-chat-widget/PbChatLauncher.vue';
import { supportChat } from '~/composables/useChatWidget';
</script>
